import { observer } from "mobx-react";
import React from "react";
import { L10n, L10nHtml } from "@fidget/common/i18n";
import { InjectedWidgetStore } from "../../../models/widget";
import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";
import { ProgressDots } from "../../progressDots/progressDots";
import styles from "./upgradePlan.css";
import { PLAN_DESCRIPTIONS, PlanType } from "./upgradeToPlanAgent";

@observer
export class UpgradeToEnterpriseAdmin extends React.Component {
  totalSteps = 0;

  get injected(): InjectedWidgetStore {
    return this.props as InjectedWidgetStore;
  }

  onLetsTalkClick = () => {
    window.location.href = `mailto:business@closer.app`;
    // TODO: In future use Closer widget for this
    // this.injected.widgetStore.updateUserDetails({ tag: "enterprise" });
    // this.injected.widgetStore.openWidget();
  };

  render() {
    return (
      <>
        <h2 className={styles.title}>
          <L10n id={"upgradePlan.upgradeToGet"} />
        </h2>
        <ProgressDots fulfilledSteps={1} totalSteps={this.totalSteps} />
        <div className={styles.content}>
          <p>
            {" "}
            <L10nHtml id={"upgradePlan.accelerate.everything"} />{" "}
          </p>
          <ul className={styles["enterprise-description"]}>
            {PLAN_DESCRIPTIONS[PlanType.ENTERPRISE].map((item) => (
              <li key={item}>
                <L10n id={item} />
              </li>
            ))}
          </ul>
          <div className={styles.pushdown}>
            <AgentButton fullWidth buttonStyle={"big orange"} onClick={this.onLetsTalkClick}>
              <L10n id={"upgradePlan.enterprise.letsTalk"} />
            </AgentButton>
          </div>
        </div>
      </>
    );
  }
}
